var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Openhouse',{staticClass:"residential-openhouse",attrs:{"value":_vm.item.openhouses}})
}
var staticRenderFns = []

export { render, staticRenderFns }